import React from "react";
import styles from "./FoundationalStage.module.css";
import { cleanLines, stripBoldTitle } from "../OnboardingStage/utils";

const parseCompliance = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  return { body: lines.join(" ").trim() };
};

const StorewideCompliance = ({ markdown = "" }) => {
  const { body } = parseCompliance(markdown);
  if (!body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Storewide & Policy Compliance</h3>
      <div className={styles.card}>
        <p className={styles.paragraph}>{body}</p>
      </div>
    </div>
  );
};

export default StorewideCompliance;
